"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Address = void 0;
var geocode_1 = require("@aidkitorg/types/lib/address/geocode");
var runtime_1 = require("@pgtyped/runtime");
var neverthrow_1 = require("neverthrow");
var db_1 = require("../../util/db");
var secrets_1 = require("@aidkitorg/gateways/dist/aws/secrets");
exports.Address = {
    getSlugs: function (params) {
        var e_1, _a;
        var slugs = [
            '_county',
            '_tract',
            '_lat',
            '_lng',
            '_building',
            '_subpremise',
            '_street',
            '_city',
            '_state',
            '_zip',
            '_plus_4',
            '_dpb',
            '_formatted',
            '_validation',
        ];
        var dependencies = [];
        var metadata = JSON.parse(params.infoDefs[params.targetField]['metadata'] || '{}');
        try {
            for (var _b = __values((metadata['lookups'] || [])), _c = _b.next(); !_c.done; _c = _b.next()) {
                var lookup = _c.value;
                slugs.push("_" + lookup);
                slugs.push("_" + lookup + "_closest");
                slugs.push("_" + lookup + "_closest_distance");
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return (0, neverthrow_1.ok)({ slugs: slugs, dependencies: dependencies });
    },
    compute: function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var countyKey, parentKey, applicantAddress, countyValue, hasCountyValue, shouldForceCompute, smartyAddressLookup, buildFieldsFromSmartyAddressLookup, readOnlyConn, googleMapsLookup, lookupResults;
            var _a, _b;
            var _this = this;
            var _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
            return __generator(this, function (_x) {
                switch (_x.label) {
                    case 0:
                        countyKey = params.targetField;
                        // Skip all other slugs
                        if (countyKey.indexOf('_county') === -1)
                            return [2 /*return*/, (0, neverthrow_1.ok)({})];
                        parentKey = countyKey.replace('_county', '');
                        applicantAddress = params.newInfoKeys[parentKey];
                        countyValue = params.newInfoKeys[parentKey + '_county'];
                        hasCountyValue = typeof countyValue === 'string' && countyValue.trim() !== '';
                        shouldForceCompute = (_d = (_c = params.computeOptions) === null || _c === void 0 ? void 0 : _c.forceComputeFields) === null || _d === void 0 ? void 0 : _d.includes(params.targetField);
                        if ((hasCountyValue && !shouldForceCompute) || !applicantAddress) {
                            return [2 /*return*/, (0, neverthrow_1.ok)({})];
                        }
                        console.debug("Roboscreener:Address: Calculating missing address geocode for address=".concat(applicantAddress, " targetField=").concat(parentKey, " program=").concat(params.deploymentKey));
                        return [4 /*yield*/, getSmartyGeocode({ address: applicantAddress })];
                    case 1:
                        smartyAddressLookup = _x.sent();
                        buildFieldsFromSmartyAddressLookup = function (smartyAddressLookup) { return __awaiter(_this, void 0, void 0, function () {
                            var lookupResults, _a;
                            var _b;
                            var _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
                            return __generator(this, function (_y) {
                                switch (_y.label) {
                                    case 0:
                                        console.debug("Roboscreener:Address: Successfully used smarty to geocode address=".concat(applicantAddress, " targetField=").concat(parentKey, " program=").concat(params.deploymentKey));
                                        if (!(typeof smartyAddressLookup.lat === 'number' && typeof smartyAddressLookup.lng === 'number')) return [3 /*break*/, 2];
                                        return [4 /*yield*/, _computeLookups({
                                                infoDefs: params.infoDefs,
                                                parentKey: parentKey,
                                                conn: params.conn,
                                                lat: smartyAddressLookup.lat,
                                                lng: smartyAddressLookup.lng,
                                            })];
                                    case 1:
                                        _a = _y.sent();
                                        return [3 /*break*/, 3];
                                    case 2:
                                        _a = {};
                                        _y.label = 3;
                                    case 3:
                                        lookupResults = _a;
                                        return [2 /*return*/, (0, neverthrow_1.ok)(__assign(__assign({}, lookupResults), (_b = {}, _b[parentKey + '_street'] = (_d = (_c = smartyAddressLookup.smartyResponse) === null || _c === void 0 ? void 0 : _c.components.street) !== null && _d !== void 0 ? _d : '', _b[parentKey + '_city'] = (_f = (_e = smartyAddressLookup.smartyResponse) === null || _e === void 0 ? void 0 : _e.components.city_name) !== null && _f !== void 0 ? _f : '', _b[parentKey + '_state'] = (_h = (_g = smartyAddressLookup.smartyResponse) === null || _g === void 0 ? void 0 : _g.components.state_abbreviation) !== null && _h !== void 0 ? _h : '', _b[parentKey + '_zip'] = (_k = (_j = smartyAddressLookup.smartyResponse) === null || _j === void 0 ? void 0 : _j.components.zipcode) !== null && _k !== void 0 ? _k : '', _b[parentKey + '_plus_4'] = (_m = (_l = smartyAddressLookup.smartyResponse) === null || _l === void 0 ? void 0 : _l.components.plus4_code) !== null && _m !== void 0 ? _m : '', _b[parentKey + '_dpb'] = (_p = (_o = smartyAddressLookup.smartyResponse) === null || _o === void 0 ? void 0 : _o.delivery_point_barcode) !== null && _p !== void 0 ? _p : '', _b[parentKey + '_county'] = smartyAddressLookup.county, _b[parentKey + '_tract'] = smartyAddressLookup.census_tract, _b[parentKey + '_subpremise'] = (_q = smartyAddressLookup.subpremise) !== null && _q !== void 0 ? _q : '', _b[parentKey + '_building'] = (_r = smartyAddressLookup.building) !== null && _r !== void 0 ? _r : '', _b[parentKey + '_lat'] = (_t = (_s = smartyAddressLookup.lat) === null || _s === void 0 ? void 0 : _s.toString()) !== null && _t !== void 0 ? _t : '', _b[parentKey + '_lng'] = (_v = (_u = smartyAddressLookup.lng) === null || _u === void 0 ? void 0 : _u.toString()) !== null && _v !== void 0 ? _v : '', _b[parentKey + '_validation'] = (0, geocode_1.smartyDpvMatchCodeToString)((_x = (_w = smartyAddressLookup.smartyResponse) === null || _w === void 0 ? void 0 : _w.analysis) === null || _x === void 0 ? void 0 : _x.dpv_match_code), _b)))];
                                }
                            });
                        }); };
                        // If smarty was successful, update the relevant Address slugs and return.
                        if (typeof smartyAddressLookup.lat === 'number' && typeof smartyAddressLookup.lng === 'number' && ((_e = smartyAddressLookup.smartyResponse) === null || _e === void 0 ? void 0 : _e.metadata.precise)) {
                            return [2 /*return*/, buildFieldsFromSmartyAddressLookup(smartyAddressLookup)];
                        }
                        return [4 /*yield*/, (0, db_1.getReadOnlyDbConn)(params.deploymentKey)];
                    case 2:
                        readOnlyConn = _x.sent();
                        if (readOnlyConn.isErr()) {
                            console.debug("Roboscreener:Address: Failed to get readonly db conn for address geocoding program=".concat(params.deploymentKey));
                            return [2 /*return*/, (0, neverthrow_1.ok)({})];
                        }
                        console.debug("Roboscreener:Address: Using google maps as fallback to geocode address=".concat(applicantAddress, " targetField=").concat(parentKey, " program=").concat(params.deploymentKey));
                        return [4 /*yield*/, getGoogleGeocode({ address: applicantAddress })];
                    case 3:
                        googleMapsLookup = _x.sent();
                        if (!(googleMapsLookup && typeof googleMapsLookup.lat === 'number' && typeof googleMapsLookup.lng === 'number')) return [3 /*break*/, 5];
                        console.debug("Roboscreener:Address: Successfully used google maps to geocode address=".concat(applicantAddress, " targetField=").concat(parentKey, " program=").concat(params.deploymentKey));
                        return [4 /*yield*/, _computeLookups({
                                infoDefs: params.infoDefs,
                                parentKey: parentKey,
                                conn: params.conn,
                                lat: googleMapsLookup.lat,
                                lng: googleMapsLookup.lng
                            })];
                    case 4:
                        lookupResults = _x.sent();
                        return [2 /*return*/, (0, neverthrow_1.ok)(__assign(__assign({}, lookupResults), (_a = {}, _a[parentKey + '_street'] = "".concat((_f = googleMapsLookup.googleMapsResponse) === null || _f === void 0 ? void 0 : _f.street_number, " ").concat((_g = googleMapsLookup.googleMapsResponse) === null || _g === void 0 ? void 0 : _g.street_name) + (((_h = googleMapsLookup.googleMapsResponse) === null || _h === void 0 ? void 0 : _h.subpremise) ? " ".concat((_j = googleMapsLookup.googleMapsResponse) === null || _j === void 0 ? void 0 : _j.subpremise) : ''), _a[parentKey + '_city'] = (_l = (_k = googleMapsLookup.googleMapsResponse) === null || _k === void 0 ? void 0 : _k.city) !== null && _l !== void 0 ? _l : '', _a[parentKey + '_state'] = (_o = (_m = googleMapsLookup.googleMapsResponse) === null || _m === void 0 ? void 0 : _m.state) !== null && _o !== void 0 ? _o : '', _a[parentKey + '_county'] = (_q = (_p = googleMapsLookup.googleMapsResponse) === null || _p === void 0 ? void 0 : _p.county) !== null && _q !== void 0 ? _q : '', _a[parentKey + '_subpremise'] = (_s = (_r = googleMapsLookup.googleMapsResponse) === null || _r === void 0 ? void 0 : _r.subpremise) !== null && _s !== void 0 ? _s : '', _a[parentKey + '_zip'] = (_u = (_t = googleMapsLookup.googleMapsResponse) === null || _t === void 0 ? void 0 : _t.zipcode) !== null && _u !== void 0 ? _u : '', _a[parentKey + '_plus_4'] = (_w = (_v = googleMapsLookup.googleMapsResponse) === null || _v === void 0 ? void 0 : _v.plus4_code) !== null && _w !== void 0 ? _w : '', _a[parentKey + '_lat'] = googleMapsLookup.lat.toString(), _a[parentKey + '_lng'] = googleMapsLookup.lng.toString(), _a[parentKey + '_validation'] = (0, geocode_1.smartyDpvMatchCodeToString)('Y'), _a)))];
                    case 5:
                        // If neither Google nor Smarty have returned precise lat/lng results but Smarty has returned
                        // everything else, use it but remove the imprecise lat/lng.
                        if (typeof smartyAddressLookup.lat === 'number' && typeof smartyAddressLookup.lng === 'number') {
                            return [2 /*return*/, buildFieldsFromSmartyAddressLookup((0, geocode_1.removeLatLngFromSmartyAddressLookup)(smartyAddressLookup))];
                        }
                        // If we can't find it from smarty or google maps (if enabled), save as Unknown so we don't compute again
                        // in the future
                        return [2 /*return*/, (0, neverthrow_1.ok)((_b = {}, _b[parentKey + '_county'] = 'Unknown', _b))];
                }
            });
        });
    }
};
// Follows similar logic as packages/aidkit/lib/geo/address
var getGoogleGeocode = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var address, googleKey, e_2, encodedAddress, url, response, data, result, streetNumber, subpremise, streetName, city, state, county, zipcode, plus4Code, countyName;
    var _a, _b, _c, _d, _e, _f, _g;
    return __generator(this, function (_h) {
        switch (_h.label) {
            case 0:
                address = params.address;
                _h.label = 1;
            case 1:
                _h.trys.push([1, 3, , 4]);
                return [4 /*yield*/, (0, secrets_1.getGlobalConfig)('GOOGLE_KEY')];
            case 2:
                googleKey = _h.sent();
                return [3 /*break*/, 4];
            case 3:
                e_2 = _h.sent();
                console.warn("Roboscreener:Address: Cannot optimistically compute Address derived fields. Failed to fetch Google Maps API key", e_2);
                return [2 /*return*/, null];
            case 4:
                encodedAddress = encodeURIComponent(address);
                url = "https://maps.googleapis.com/maps/api/geocode/json?address=".concat(encodedAddress, "&key=").concat(googleKey);
                return [4 /*yield*/, fetch(url, {
                        method: "GET",
                        headers: { "Content-Type": "application/json" },
                    })];
            case 5:
                response = _h.sent();
                return [4 /*yield*/, response.json()];
            case 6:
                data = _h.sent();
                if (data.results && data.results.length > 0) {
                    result = data.results[0];
                    streetNumber = result.address_components.find(function (component) { return component.types.includes('street_number'); });
                    subpremise = result.address_components.find(function (component) { return component.types.includes('subpremise'); });
                    streetName = result.address_components.find(function (component) { return component.types.includes('route'); });
                    city = result.address_components.find(function (component) { return component.types.includes('locality'); });
                    state = result.address_components.find(function (component) { return component.types.includes('administrative_area_level_1'); });
                    county = result.address_components.find(function (component) { return component.types.includes('administrative_area_level_2'); });
                    zipcode = result.address_components.find(function (component) { return component.types.includes('postal_code'); });
                    plus4Code = result.address_components.find(function (component) { return component.types.includes('postal_code_suffix'); });
                    if (!result.address_components ||
                        result.partial_match === true ||
                        result.geometry.location_type !== 'ROOFTOP' ||
                        !streetNumber || !streetName || !city || !state || !county || !zipcode) {
                        return [2 /*return*/, null];
                    }
                    countyName = county.long_name.replace(/ County$/, '');
                    return [2 /*return*/, __assign(__assign({}, result.geometry.location), { 'lat': result.geometry.location.lat, 'lng': result.geometry.location.lng, 'county': countyName, 'found_street_number': !!streetNumber, 'census_tract': '', googleMapsResponse: {
                                lat: result.geometry.location.lat,
                                lng: result.geometry.location.lng,
                                formatted_address: result.formatted_address,
                                county: countyName,
                                subpremise: (_a = subpremise === null || subpremise === void 0 ? void 0 : subpremise.short_name) !== null && _a !== void 0 ? _a : '',
                                street_number: (_b = streetNumber.short_name) !== null && _b !== void 0 ? _b : '',
                                street_name: (_c = streetName === null || streetName === void 0 ? void 0 : streetName.short_name) !== null && _c !== void 0 ? _c : '',
                                city: (_d = city === null || city === void 0 ? void 0 : city.long_name) !== null && _d !== void 0 ? _d : '',
                                state: (_e = state === null || state === void 0 ? void 0 : state.short_name) !== null && _e !== void 0 ? _e : '',
                                zipcode: (_f = zipcode === null || zipcode === void 0 ? void 0 : zipcode.short_name) !== null && _f !== void 0 ? _f : '',
                                plus4_code: (_g = plus4Code === null || plus4Code === void 0 ? void 0 : plus4Code.short_name) !== null && _g !== void 0 ? _g : '',
                            } })];
                }
                return [2 /*return*/, null];
        }
    });
}); };
// Follows similar logic as packages/aidkit/lib/geo/address
var getSmartyGeocode = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var baseUrl, authId, authToken, encodedAddress, url, data, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                baseUrl = "https://us-street.api.smartystreets.com/street-address";
                return [4 /*yield*/, (0, secrets_1.getGlobalConfig)("SMARTY_AUTH_ID")];
            case 1:
                authId = _a.sent();
                return [4 /*yield*/, (0, secrets_1.getGlobalConfig)("SMARTY_AUTH_TOKEN")];
            case 2:
                authToken = _a.sent();
                encodedAddress = encodeURIComponent(params.address);
                url = "".concat(baseUrl, "?license=us-rooftop-geocoding-enterprise-cloud&auth-id=").concat(authId, "&auth-token=").concat(authToken, "&street=").concat(encodedAddress, "&candidates=10");
                return [4 /*yield*/, fetch(url, { method: "GET" })];
            case 3:
                data = _a.sent();
                return [4 /*yield*/, data.json()];
            case 4:
                response = (_a.sent())[0];
                return [2 /*return*/, {
                        lat: response === null || response === void 0 ? void 0 : response.metadata.latitude,
                        lng: response === null || response === void 0 ? void 0 : response.metadata.longitude,
                        county: response === null || response === void 0 ? void 0 : response.metadata.county_name,
                        found_street_number: (response === null || response === void 0 ? void 0 : response.analysis.dpv_match_code) !== 'N',
                        census_tract: '',
                        lookups: {},
                        smartyResponse: {
                            analysis: {
                                dpv_match_code: response === null || response === void 0 ? void 0 : response.analysis.dpv_match_code,
                                dpv_footnotes: response === null || response === void 0 ? void 0 : response.analysis.dpv_footnotes,
                            },
                            components: {
                                street: [
                                    response === null || response === void 0 ? void 0 : response.components.primary_number,
                                    response === null || response === void 0 ? void 0 : response.components.street_predirection,
                                    response === null || response === void 0 ? void 0 : response.components.street_name,
                                    response === null || response === void 0 ? void 0 : response.components.street_suffix,
                                    response === null || response === void 0 ? void 0 : response.components.street_postdirection,
                                ].filter(function (x) { return x; }).join(' '),
                                secondary: [
                                    response === null || response === void 0 ? void 0 : response.components.secondary_designator,
                                    response === null || response === void 0 ? void 0 : response.components.secondary_number,
                                ].filter(function (x) { return x; }).join(' '),
                                city_name: response === null || response === void 0 ? void 0 : response.components.city_name,
                                zipcode: response === null || response === void 0 ? void 0 : response.components.zipcode,
                                plus4_code: response === null || response === void 0 ? void 0 : response.components.plus4_code,
                                state_abbreviation: response === null || response === void 0 ? void 0 : response.components.state_abbreviation
                            },
                            metadata: {
                                latitude: response === null || response === void 0 ? void 0 : response.metadata.latitude,
                                longitude: response === null || response === void 0 ? void 0 : response.metadata.longitude,
                                precise: (0, geocode_1.isSmartyResponsePrecise)(response),
                            },
                            delivery_line_1: response === null || response === void 0 ? void 0 : response.delivery_line_1,
                            last_line: response === null || response === void 0 ? void 0 : response.last_line,
                            delivery_point_barcode: response === null || response === void 0 ? void 0 : response.delivery_point_barcode
                        },
                    }];
        }
    });
}); };
// Returns an object with lookup results if we're able to 
// process the lookups successfully with the new geocoded values.
// This follows the updates Object pattern for keys that should 
// be changed as a result of this roboscreener calculation.
var _computeLookups = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var infoDefs, parentKey, conn, lat, lng, lookupUpdates, getLookupValue, getClosestValue, metadata, _a, _b, lookup, lookupResult, closestValue, e_3_1, _c, _d, lookup;
    var e_3, _e, e_4, _f;
    var _g, _h, _j, _k, _l, _m;
    return __generator(this, function (_o) {
        switch (_o.label) {
            case 0:
                infoDefs = params.infoDefs, parentKey = params.parentKey, conn = params.conn, lat = params.lat, lng = params.lng;
                lookupUpdates = {};
                getLookupValue = (0, runtime_1.sql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      SELECT value \n          FROM geolookup \n          WHERE \n            (\n              ST_CONTAINS(shape, ST_SetSRID(ST_MakePoint($lng, $lat), 4326)) OR\n              (ST_Dimension(shape) = 0 AND ST_DWithin(shape, ST_SetSRID(ST_MakePoint($lng, $lat), 4326), 0))\n            )\n          and kind = $lookup\n          LIMIT 1;\n  "], ["\n      SELECT value \n          FROM geolookup \n          WHERE \n            (\n              ST_CONTAINS(shape, ST_SetSRID(ST_MakePoint($lng, $lat), 4326)) OR\n              (ST_Dimension(shape) = 0 AND ST_DWithin(shape, ST_SetSRID(ST_MakePoint($lng, $lat), 4326), 0))\n            )\n          and kind = $lookup\n          LIMIT 1;\n  "])));
                getClosestValue = (0, runtime_1.sql)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    SELECT\n      value,\n      ST_Distance(\n        ST_Boundary(shape)::GEOGRAPHY,\n        ST_SetSRID(ST_MakePoint($lng, $lat), 4326)::GEOGRAPHY\n      ) AS distance\n    FROM geolookup\n    WHERE kind = $lookup\n      AND ($value::TEXT IS NULL OR value = $value)\n    ORDER BY distance ASC\n    LIMIT 1;\n  "], ["\n    SELECT\n      value,\n      ST_Distance(\n        ST_Boundary(shape)::GEOGRAPHY,\n        ST_SetSRID(ST_MakePoint($lng, $lat), 4326)::GEOGRAPHY\n      ) AS distance\n    FROM geolookup\n    WHERE kind = $lookup\n      AND ($value::TEXT IS NULL OR value = $value)\n    ORDER BY distance ASC\n    LIMIT 1;\n  "])));
                metadata = JSON.parse(infoDefs[parentKey].metadata || '{}');
                if (!(conn && typeof lat === 'number' && typeof lng === 'number')) return [3 /*break*/, 10];
                _o.label = 1;
            case 1:
                _o.trys.push([1, 7, 8, 9]);
                _a = __values((metadata['lookups'] || [])), _b = _a.next();
                _o.label = 2;
            case 2:
                if (!!_b.done) return [3 /*break*/, 6];
                lookup = _b.value;
                console.log("Checking lookup " + lookup + " for field " + parentKey);
                return [4 /*yield*/, getLookupValue.run({ lng: lng, lat: lat, lookup: lookup }, conn)];
            case 3:
                lookupResult = _o.sent();
                if (lookupResult.length) {
                    lookupUpdates[lookup] = lookupResult[0].value;
                    lookupUpdates[parentKey + '_' + lookup] = lookupResult[0].value;
                }
                else {
                    lookupUpdates[lookup] = '';
                    lookupUpdates[parentKey + '_' + lookup] = '';
                }
                return [4 /*yield*/, getClosestValue.run({ lng: lng, lat: lat, lookup: lookup, value: (_g = lookupResult[0]) === null || _g === void 0 ? void 0 : _g.value }, conn)];
            case 4:
                closestValue = _o.sent();
                lookupUpdates[parentKey + '_' + lookup + '_closest'] = (_j = (_h = closestValue[0]) === null || _h === void 0 ? void 0 : _h.value) !== null && _j !== void 0 ? _j : '';
                lookupUpdates[parentKey + '_' + lookup + '_closest_distance'] = (_m = (_l = (_k = closestValue[0]) === null || _k === void 0 ? void 0 : _k.distance) === null || _l === void 0 ? void 0 : _l.toString()) !== null && _m !== void 0 ? _m : '';
                _o.label = 5;
            case 5:
                _b = _a.next();
                return [3 /*break*/, 2];
            case 6: return [3 /*break*/, 9];
            case 7:
                e_3_1 = _o.sent();
                e_3 = { error: e_3_1 };
                return [3 /*break*/, 9];
            case 8:
                try {
                    if (_b && !_b.done && (_e = _a.return)) _e.call(_a);
                }
                finally { if (e_3) throw e_3.error; }
                return [7 /*endfinally*/];
            case 9: return [3 /*break*/, 11];
            case 10:
                try {
                    for (_c = __values((metadata['lookups'] || [])), _d = _c.next(); !_d.done; _d = _c.next()) {
                        lookup = _d.value;
                        lookupUpdates[lookup] = '';
                        lookupUpdates[parentKey + '_' + lookup] = '';
                    }
                }
                catch (e_4_1) { e_4 = { error: e_4_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_f = _c.return)) _f.call(_c);
                    }
                    finally { if (e_4) throw e_4.error; }
                }
                _o.label = 11;
            case 11: return [2 /*return*/, lookupUpdates];
        }
    });
}); };
var templateObject_1, templateObject_2;
